import { render, staticRenderFns } from "./UserInfoWebpart.vue?vue&type=template&id=76c07328"
import script from "./UserInfoWebpart.ts?vue&type=script&lang=ts&external"
export * from "./UserInfoWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports